import React from 'react'
import PropTypes from 'prop-types'

import Text from 'components/common/Text'
import theme from 'theme'

const TargetGraphLegend = React.memo(function TargetGraphLegend({
  items,
  ...rest
}) {
  return (
    <ul
      css={{
        listStyle: 'none',
        margin: 0,
        padding: theme.space[3],
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(96px, 1fr))',
        columnGap: theme.space[3],
        rowGap: theme.space[1],
        textAlign: 'left'
      }}
      {...rest}
    >
      {items.map(({ label, text, color }) => {
        return (
          <li
            key={label}
            css={{
              display: 'grid',
              gridTemplateColumns: 'auto 1fr',
              gap: theme.space[2],
              alignItems: 'center'
            }}
          >
            <div
              css={{
                width: theme.space[3],
                height: theme.space[3],
                borderRadius: theme.borderRadius[2],
                backgroundColor: color
              }}
            />
            <div
              css={{
                display: 'grid',
                gridTemplateColumns: `${theme.space[7]}px 1fr`,
                alignItems: 'center',
                gap: theme.space[5]
              }}
            >
              <Text
                as="h6"
                css={{
                  textTransform: 'capitalize',
                  color: theme.colors.steel[2],
                  whiteSpace: 'nowrap'
                }}
              >
                {label}
              </Text>
              {text && (
                <Text
                  css={{
                    fontSize: theme.fontSizes[0],
                    color: theme.colors.steel[1]
                  }}
                >
                  {text}
                </Text>
              )}
            </div>
          </li>
        )
      })}
    </ul>
  )
})

TargetGraphLegend.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, color: PropTypes.string })
  )
}

export default TargetGraphLegend
